(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format((cents || 0) / 100);
  const toast = (message) => {
    let el = document.querySelector('.bbx-toast');
    if (!el) { el = document.createElement('div'); el.className = 'bbx-toast'; el.setAttribute('role','status'); document.body.appendChild(el); }
    el.textContent = message; el.classList.add('is-visible'); clearTimeout(el._timer); el._timer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };
  const updateCartCount = async () => {
    try { const cart = await fetch('/cart.js').then(r => r.json()); document.querySelectorAll('[data-bbx-cart-count]').forEach(el => el.textContent = cart.item_count); } catch(e) {}
  };
  const signalCartAdded = (quantity, button) => {
    const targets = [...document.querySelectorAll('[data-bbx-cart-link]')];
    if (button) targets.push(button);
    if (button?.closest('[data-bbx-product]')) targets.push(...document.querySelectorAll('[data-bbx-sticky-submit]'));
    targets.forEach(link => {
      let feedback = link.querySelector('[data-bbx-cart-feedback]');
      if (!feedback) { feedback = document.createElement('span'); feedback.className = 'bbx-cart-feedback'; feedback.setAttribute('data-bbx-cart-feedback',''); feedback.setAttribute('aria-hidden','true'); link.append(feedback); }
      clearTimeout(link._bbxFeedbackTimer);
      feedback.textContent = `+${Math.max(1, Number(quantity) || 1)}`;
      link.classList.remove('is-cart-added'); void link.offsetWidth; link.classList.add('is-cart-added');
      link._bbxFeedbackTimer = setTimeout(() => { link.classList.remove('is-cart-added'); feedback.textContent = ''; }, 1800);
    });
  };
  const showVariantMedia = (root, mediaId, animate = false) => {
    if (!mediaId) return;
    const gallery = root.querySelector('[data-bbx-slides], .bbx-product__media'); if (!gallery) return;
    const target = [...gallery.children].find(slide => slide.dataset.mediaId === String(mediaId)); if (!target) return;
    const image = target.querySelector('img'); if (image) image.loading = 'eager';
    {
      const left = target.getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft;
      const behavior = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
      gallery.scrollTo({left, behavior});
      const index = [...gallery.children].indexOf(target);
      root.querySelectorAll('.bbx-card__dots i').forEach((dot,i) => dot.classList.toggle('is-active', i === index));
    }
  };
  const isLowStock = (variant, stock) => Boolean(variant?.available && stock?.inventory_management && Number.isInteger(stock.inventory_quantity) && stock.inventory_quantity > 0 && stock.inventory_quantity <= 20);
  const syncLowStock = (root, variant, stock) => {
    const warning = root.querySelector('[data-bbx-low-stock]'); if (!warning) return;
    const visible = isLowStock(variant, stock); warning.hidden = !visible;
    const text = warning.querySelector('[data-bbx-stock-text]');
    const template = stock?.inventory_policy === 'continue' ? warning.dataset.stockBackorderTemplate : warning.dataset.stockTemplate;
    if (text) text.textContent = visible ? template.replace('__COUNT__', String(stock.inventory_quantity)) : '';
  };
  const selectedOptions = (root) => [...root.querySelectorAll('[data-bbx-option].is-selected, [data-bbx-select]')].sort((a,b) => +a.dataset.optionPosition - +b.dataset.optionPosition).map(x => x.matches('select') ? x.value : x.dataset.optionValue);
  const setupVariantRoot = (root) => {
    const json = root.querySelector('[data-bbx-variants]'); if (!json) return;
    let variants; try { variants = JSON.parse(json.textContent); } catch(e) { return; }
    let metadata = {}; try { metadata = JSON.parse(root.querySelector('[data-bbx-variant-metadata]')?.textContent || '{}'); } catch(e) {}
    const input = root.querySelector('[data-bbx-variant-id]'); const add = root.querySelector('[data-bbx-add]'); const label = root.querySelector('[data-bbx-add-label]'); const price = root.querySelector('[data-bbx-price]');
    const sync = (animate = false) => {
      const opts = selectedOptions(root); const variant = opts.length ? variants.find(v => v.options.every((o,i) => o === opts[i])) : (variants.find(v => v.available) || variants[0]);
      root.dataset.bbxAvailable = String(Boolean(variant?.available));
      syncLowStock(root, variant, metadata[variant?.id]);
      if (variant) {
        root.dataset.bbxVariantId = String(variant.id); if (input) { input.value = String(variant.id); input.setAttribute('value', String(variant.id)); }
        root.querySelectorAll('[data-bbx-quick-add]').forEach(form => form.dataset.variantId = String(variant.id));
        root.querySelectorAll('[data-bbx-plan-options]').forEach(group=>{const active=group.dataset.bbxPlanOptions===String(variant.id);group.hidden=!active;group.querySelectorAll('[name="selling_plan"]').forEach(control=>control.disabled=!active);});
        const plan = root.querySelector('[data-bbx-plan-select]:not(:disabled), [data-bbx-plan-fixed]:not(:disabled)');
        const planOption = plan?.selectedOptions?.[0] || plan;
        const activePrice = planOption?.dataset.planPrice ? Number(planOption.dataset.planPrice) : variant.price;
        const comparePrice = planOption?.dataset.planComparePrice ? Number(planOption.dataset.planComparePrice) : variant.compare_at_price;
        if (price) price.innerHTML = `<strong>${money(activePrice)}</strong>${comparePrice > activePrice ? `<s>${money(comparePrice)}</s>` : ''}`;
        if (root.hasAttribute('data-bbx-product')) {
          document.querySelectorAll('[data-bbx-sticky-price]').forEach(el => el.textContent = money(activePrice));
          if (animate) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState(null, '', url); }
        }
        if (add) add.disabled = !variant.available || root.querySelector('[data-bbx-quick-add]')?.dataset.bbxBusy === '1'; if (label) label.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        const sale = root.querySelector('[data-bbx-sale]'); if (sale) sale.hidden = !(variant.compare_at_price > variant.price);
        showVariantMedia(root, metadata[variant.id]?.media_id || variant.featured_media?.id, animate);

      } else { if (add) add.disabled = true; if (label) label.textContent = 'Nicht verfügbar'; }
      if (root.hasAttribute('data-bbx-product')) {
        const requiredPlan = root.querySelector('[data-bbx-plan-select][required]:not(:disabled)');
        document.querySelectorAll('[data-bbx-sticky-submit]').forEach(btn => {
          btn.disabled = !variant?.available || root.querySelector('[data-bbx-quick-add]')?.dataset.bbxBusy === '1';
          btn.textContent = !variant?.available ? 'Ausverkauft' : requiredPlan && !requiredPlan.value ? 'Abo auswählen' : 'In den Warenkorb';
        });
      }
      root.querySelectorAll('[data-bbx-option]').forEach(btn => {
        btn.setAttribute('aria-pressed', String(btn.classList.contains('is-selected')));
        const pos = +btn.dataset.optionPosition - 1; const test = [...opts]; test[pos] = btn.dataset.optionValue;
        const possible = variants.some(v => v.available && v.options.every((o,i) => test[i] ? o === test[i] : true)); btn.classList.toggle('is-unavailable', !possible);
      });
      root.querySelectorAll('[data-bbx-select]').forEach(select => [...select.options].forEach(option => {
        const pos = +select.dataset.optionPosition - 1;
        option.disabled = !variants.some(v => v.available && v.options[pos] === option.value);
      }));
    };
    root.querySelectorAll('[data-bbx-option]').forEach(btn => btn.addEventListener('click', () => {
      root.querySelectorAll(`[data-bbx-option][data-option-position="${btn.dataset.optionPosition}"]`).forEach(x => x.classList.remove('is-selected')); btn.classList.add('is-selected');
      const legend = btn.closest('fieldset')?.querySelector('[data-option-label]'); if (legend) legend.textContent = btn.dataset.optionValue; sync(true);
    }));
    root.querySelectorAll('[data-bbx-select]').forEach(select => select.addEventListener('change', () => {
      const opts = selectedOptions(root);
      const pos = +select.dataset.optionPosition - 1;
      const exact = variants.find(v => v.available && v.options.every((o,i) => o === opts[i]));
      if (!exact) {
        const candidates = variants.filter(v => v.available && v.options[pos] === select.value);
        const score = v => v.options.reduce((total, value, index) => total + Number(value === opts[index]), 0);
        candidates.sort((a,b) => score(b) - score(a));
        const next = candidates[0];
        if (next) root.querySelectorAll('[data-bbx-select]').forEach(control => {
          control.value = next.options[+control.dataset.optionPosition - 1];
        });
      }
      const legend = select.closest('fieldset')?.querySelector('[data-option-label]'); if (legend) legend.textContent = select.value; sync(true);
    }));
    root.querySelectorAll('[data-bbx-plan-select]').forEach(select => select.addEventListener('change', () => sync()));
    sync();
  };
  const setupGallery = (root) => {
    const slides = root.querySelector('[data-bbx-slides], .bbx-product__media'); if (!slides) return;
    const move = d => slides.scrollBy({left:d * slides.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    root.querySelector('[data-bbx-gallery-prev]')?.addEventListener('click', e => { e.preventDefault(); move(-1); });
    root.querySelector('[data-bbx-gallery-next]')?.addEventListener('click', e => { e.preventDefault(); move(1); });
    const update = () => {
      const i = Math.min(slides.children.length - 1, Math.max(0, Math.round(slides.scrollLeft / Math.max(slides.clientWidth,1))));
      root.querySelectorAll('.bbx-card__dots i').forEach((d,n) => d.classList.toggle('is-active',n === i));
      const count = root.querySelector('[data-bbx-gallery-count]');
      if (count) count.textContent = `${i + 1} / ${slides.children.length}`;
      if (slides.matches('.bbx-product__media')) {
        root.querySelector('[data-bbx-gallery-prev]')?.toggleAttribute('disabled', i === 0);
        root.querySelector('[data-bbx-gallery-next]')?.toggleAttribute('disabled', i === slides.children.length - 1);
      }
    };
    slides.addEventListener('scroll', update, {passive:true});
    slides.addEventListener('keydown', e => { if (e.target !== slides) return; if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1); } });
    update();
  };
  const quickAdd = async (form) => {
    if (form.dataset.bbxBusy === '1') return;
    if (form.checkValidity && !form.checkValidity()) { form.reportValidity(); return; }
    const owner = form.closest('[data-bbx-card], [data-bbx-product]');
    if (owner?.dataset.bbxAvailable === 'false') return;
    form.dataset.bbxBusy = '1';
    form.setAttribute('aria-busy', 'true');
    const stickyButtons = owner?.hasAttribute('data-bbx-product') ? [...document.querySelectorAll('[data-bbx-sticky-submit]')] : [];
    stickyButtons.forEach(btn => btn.disabled = true);
    const button = form.querySelector('[data-bbx-add]'); const label = form.querySelector('[data-bbx-add-label]'); const original = label?.textContent;
    const finish = () => {
      delete form.dataset.bbxBusy; form.removeAttribute('aria-busy');
      const available = owner?.dataset.bbxAvailable !== 'false';
      if (label) label.textContent = available ? original : 'Ausverkauft';
      button?.classList.remove('is-added');
      if (button) button.disabled = !available;
      stickyButtons.forEach(btn => btn.disabled = !available);
    };
    if (button) button.disabled = true; if (label) label.textContent = 'Wird hinzugefügt …';
    try {
      const owner = form.closest('[data-bbx-card], [data-bbx-product]'); const variantId = owner?.dataset.bbxVariantId || form.dataset.variantId || form.querySelector('[name="id"]')?.value; const quantity = form.querySelector('[name="quantity"]')?.value || '1';
      if (!variantId) throw new Error('Bitte wähle zuerst eine verfügbare Variante.');
      const payload = new FormData(form); payload.set('id', variantId); payload.set('quantity', quantity);
      const res = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:payload}); const data = await res.json(); if (!res.ok) throw new Error(data.description || 'Produkt konnte nicht hinzugefügt werden.');
      if (label) label.textContent = 'Im Warenkorb ✓'; button?.classList.add('is-added'); signalCartAdded(quantity, button); toast(`${data.product_title || 'Produkt'} wurde hinzugefügt.`); await updateCartCount();
      document.dispatchEvent(new CustomEvent('bbx:cart-added', {detail:{productId:String(data.product_id)}}));
      if (form.hasAttribute('data-bbx-cart-upsell')) { window.setTimeout(() => window.location.reload(), 1800); return; }
      setTimeout(finish,1800);
    } catch(e) { toast(e.message); finish(); }
  };
  const recentOrders = {'dumpling-klicker-fidget':104,'glow-drachen':39,'bash-box':38,'der-drache':29,'bash-crazy-mix-schuttelautomat':27,'cube-fidget':14,'mini-flexi-dino-s-im-ei':13,'das-ring-fidget':7,'pebbles-der-eiskonig':4,'dexter-der-eisdrache':3,'schrauben-fidget':3,'xxl-glow-drachen':3,'halloween-fidget-1':2,'xxl-flexi-dino-s':1};
  const recommendationFamily = handle => /drachen|drache/.test(handle) ? 'dragons' : /dino|tierchen/.test(handle) ? 'animals' : /box/.test(handle) ? 'box' : /fidget|dumpling/.test(handle) ? 'fidgets' : handle;
  const rankRecommendations = (candidates, excluded, currentHandle, now=Date.now()) => {
    const ageDays = Math.max(0,(now - Date.parse('2026-09-02T08:00:00Z'))/86400000);
    const recentWeight = .9 * Math.max(0,1-ageDays/30);
    const family = recommendationFamily(currentHandle || '');
    const unique = new Map();
    candidates.forEach(c => { if(!excluded.has(String(c.id))) unique.set(String(c.id),c); });
    const pool = [...unique.values()].map(c => ({...c, family:recommendationFamily(c.handle), score:recentWeight*100*Math.sqrt((recentOrders[c.handle]||0)/104)+(1-recentWeight)*100/Math.sqrt(Math.max(1,c.rank))+(recommendationFamily(c.handle)===family?3:0)}));
    const selected=[], families=new Map();
    while(pool.length && selected.length<4){
      pool.sort((a,b)=> b.score*Math.pow(.7,families.get(b.family)||0)-a.score*Math.pow(.7,families.get(a.family)||0)||a.rank-b.rank);
      const next=pool.shift();selected.push(next);families.set(next.family,(families.get(next.family)||0)+1);
    }
    return selected;
  };
  const setupRecommendations = async root => {
    if(root.dataset.bbxReady)return;root.dataset.bbxReady='1';
    let excluded;try{excluded=new Set(JSON.parse(root.querySelector('[data-bbx-excluded]').textContent).map(String));}catch(e){return;}
    if(root.dataset.currentId)excluded.add(root.dataset.currentId);
    const list=root.querySelector('[data-bbx-recommendation-list]');let candidates=[];
    const render = () => {
      const rankingTime=Number(root.dataset.rankingTime)*1000 || Date.now();
      const selected=rankRecommendations(candidates,excluded,root.dataset.currentHandle,rankingTime);
      if(!selected.length){list.replaceChildren();root.hidden=true;return;}
      const fragment=document.createDocumentFragment();
      selected.forEach(c=>fragment.append(c.element.querySelector(`template[data-view="${root.dataset.mode}"]`).content.cloneNode(true)));
      list.replaceChildren(fragment);root.hidden=false;init(list);
    };
    document.addEventListener('bbx:cart-added',e=>{excluded.add(e.detail.productId);if(candidates.length)render();else list.querySelectorAll('[data-product-id]').forEach(el=>{if(excluded.has(el.dataset.productId))el.remove();});});
    try{
      const response=await fetch(root.dataset.source,{signal:AbortSignal.timeout(8000)});if(!response.ok)return;
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      candidates=[...doc.querySelectorAll('[data-bbx-candidate]')].map(element=>({id:element.dataset.productId,handle:element.dataset.handle,rank:Number(element.dataset.rank),element}));
      if(candidates.length){render();root.dataset.bbxRecommendationSource='bestselling-live';}
    }catch(e){root.dataset.bbxRecommendationSource='recent-sales-fallback';}
  };
  const nextSundayBerlin = (now = Date.now()) => {
    const formatter = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
    const parts = timestamp => Object.fromEntries(formatter.formatToParts(timestamp).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    const p = parts(now);
    const day = new Date(Date.UTC(p.year, p.month - 1, p.day)).getUTCDay();
    let days = (7 - day) % 7;
    if (days === 0 && p.hour >= 12) days = 7;
    const localTarget = Date.UTC(p.year, p.month - 1, p.day + days, 12);
    let target = localTarget;
    for (let i = 0; i < 3; i++) {
      const at = parts(target);
      const offset = Date.UTC(at.year, at.month - 1, at.day, at.hour, at.minute, at.second) - target;
      target = localTarget - offset;
    }
    return target;
  };
  const setupInlineNewsletter = form => {
    if (form.dataset.bbxNewsletterReady) return;
    if (form.hasAttribute('data-hcaptcha-bound')) return;
    form.dataset.bbxNewsletterReady = '1';
    let protectedSend;
    form.submit = () => protectedSend?.();
    const submit = event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.bbxNewsletterBusy === '1' || !form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-bbx-newsletter-status]');
      const challenge = form.querySelector('[data-bbx-newsletter-challenge]');
      if (!button || !status) return;
      form.dataset.bbxNewsletterBusy = '1'; form.setAttribute('aria-busy', 'true'); button.disabled = true;
      status.hidden = false; status.textContent = status.dataset.sending;
      form.querySelector('[data-bbx-newsletter-errors]')?.remove();
      if (challenge) challenge.hidden = true;
      let finished = false, sent = false;
      const finish = message => {
        if (finished) return;
        finished = true; clearTimeout(timeout);
        status.textContent = message; button.disabled = false;
        delete form.dataset.bbxNewsletterBusy; form.removeAttribute('aria-busy');
      };
      const timeout = setTimeout(() => finish(status.dataset.error), 30000);
      const send = async () => {
        if (finished || sent || !form.isConnected) return;
        sent = true;
        try {
          const response = await fetch(form.action, {method:'POST', body:new URLSearchParams(new FormData(form)), credentials:'same-origin', headers:{Accept:'text/html'}, signal:AbortSignal.timeout(20000)});
          const resultURL = new URL(response.url);
          if (resultURL.origin === location.origin && resultURL.pathname.includes('/challenge')) {
            if (challenge) { challenge.href = resultURL.href; challenge.hidden = false; }
            finish(status.dataset.security); return;
          }
          if (!response.ok) throw new Error('Newsletter response failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const returnedForm = doc.getElementById(form.id);
          const success = returnedForm?.querySelector('[data-bbx-newsletter-success]');
          const errors = returnedForm?.querySelector('[data-bbx-newsletter-errors]');
          if (finished) return;
          if (success) {
            form.querySelector('.bbx-newsletter__fields').hidden = true;
            finish(success.textContent.trim());
          } else finish(errors?.textContent.trim() || status.dataset.error);
        } catch (error) { finish(status.dataset.error); }
      };
      protectedSend = send;
      try {
        if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(form, () => form.submit());
        else form.submit();
      } catch (error) { finish(status.dataset.error); }
    };
    form.addEventListener('submit', submit, true);
    form.querySelector('button[type="submit"]')?.addEventListener('click', submit, true);
    form.querySelector('input[type="email"]')?.addEventListener('keydown', event => {
      if (event.key === 'Enter') submit(event);
    });
    window.Shopify?.captcha?.protect?.(form);
  };
  const init = (scope=document) => {
    scope.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && (url.pathname.endsWith('/collections/all') || url.pathname.endsWith('/collections/all/')) && !url.searchParams.get('sort_by')) {
        url.searchParams.set('sort_by', 'best-selling');
        link.href = url.pathname + url.search + url.hash;
      }
    });
    scope.querySelectorAll('[data-bbx-card], [data-bbx-product]').forEach(root => { if (root.dataset.bbxReady) return; root.dataset.bbxReady='1'; setupVariantRoot(root); setupGallery(root); });
    scope.querySelectorAll('[data-bbx-quick-add]').forEach(form => { if (form.dataset.bbxReady) return; form.dataset.bbxReady='1'; form.addEventListener('submit',e => { e.preventDefault(); quickAdd(form); }); });
    scope.querySelectorAll('[data-bbx-recommendations]').forEach(setupRecommendations);
    scope.querySelectorAll('[data-bbx-inline-newsletter="true"]').forEach(setupInlineNewsletter);
    scope.querySelectorAll('[data-bbx-qty]').forEach(q => { if(q.dataset.bbxReady)return;q.dataset.bbxReady='1'; const input=q.querySelector('input'); q.querySelector('[data-minus]')?.addEventListener('click',()=>input.value=Math.max(1,+input.value-1)); q.querySelector('[data-plus]')?.addEventListener('click',()=>input.value=Math.max(1,+input.value+1)); });
    scope.querySelectorAll('[data-bbx-countdown]').forEach(el => {
      if (el.dataset.bbxReady) return;
      el.dataset.bbxReady = '1';
      const weekly = el.dataset.weeklySunday === 'true';
      let target = weekly ? nextSundayBerlin() : new Date(el.dataset.target).getTime();
      const showDate = () => {
        if (!weekly) return;
        el.dataset.target = new Date(target).toISOString();
        const date = el.closest('.bbx-drop')?.querySelector('[data-bbx-drop-date]');
        if (date) { date.dateTime = new Date(target).toISOString(); date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {timeZone:'Europe/Berlin', weekday:'long', day:'numeric', month:'long'}).format(target) + ' · 12:00 (Berlin)'; }
      };
      showDate();
      let timer;
      const tick = () => {
        if (!el.isConnected) { clearInterval(timer); return; }
        const now = Date.now();
        if (weekly && target <= now) { target = nextSundayBerlin(now); showDate(); }
        const distance = target - now;
        const live = !Number.isFinite(distance) || distance <= 0;
        const id = el.dataset.dropId;
        el.hidden = live;
        document.querySelectorAll(`[data-drop-live="${id}"], [data-drop-published="${id}"]`).forEach(x => x.hidden = !live);
        document.querySelectorAll(`[data-drop-upcoming="${id}"]`).forEach(x => x.hidden = live);
        document.querySelectorAll(`[data-bbx-drop-media="${id}"]`).forEach(x => x.classList.toggle('bbx-drop__media--teaser', !live));
        if (live || !el.isConnected) { clearInterval(timer); return; }
        const units = [86400000, 3600000, 60000, 1000];
        let rest = distance;
        el.querySelectorAll('[data-unit]').forEach((node, i) => {
          const n = Math.floor(rest / units[i]); rest %= units[i];
          node.textContent = String(n).padStart(2, '0');
        });
      };
      tick();
      if (!el.hidden) timer = setInterval(tick, 1000);
    });
  };
  const setMenu = open => {
    const drawer = document.querySelector('[data-bbx-drawer]'); if (!drawer) return;
    drawer.classList.toggle('is-open', open); drawer.inert = !open; drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('bbx-menu-open', open);
    const toggle = document.querySelector('[data-bbx-menu-open]'); toggle?.setAttribute('aria-expanded', String(open));
    if (open) requestAnimationFrame(() => { if (drawer.classList.contains('is-open')) drawer.querySelector('[data-bbx-menu-close]')?.focus(); });
    else toggle?.focus();
  };
  const setSearch = open => {
    const panel = document.querySelector('[data-bbx-search-panel]'); if (!panel) return;
    panel.classList.toggle('is-open', open);
    const toggle = document.querySelector('[data-bbx-search-toggle]'); toggle?.setAttribute('aria-expanded', String(open));
    (open ? panel.querySelector('input') : toggle)?.focus();
  };
  document.addEventListener('keydown', e => {
    const drawer = document.querySelector('[data-bbx-drawer].is-open');
    if (e.key === 'Escape') { if (drawer) setMenu(false); else if (document.querySelector('[data-bbx-search-panel].is-open')) setSearch(false); }
    if (e.key !== 'Tab' || !drawer) return;
    const targets = [...drawer.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = targets[0], last = targets.at(-1);
    if (!drawer.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first)?.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  });
  document.addEventListener('click', e => {
    const cookiePreferences = e.target.closest('[data-bbx-cookie-preferences]');
    if (cookiePreferences && typeof window.privacyBanner?.showPreferences === 'function') {
      e.preventDefault();
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => { window.location.assign(cookiePreferences.href); });
    }
    const announcementToggle = e.target.closest('[data-bbx-announcement-toggle]');
    if (announcementToggle) {
      const paused = announcementToggle.closest('.bbx-announcement').classList.toggle('bbx-announcement--paused');
      announcementToggle.setAttribute('aria-pressed', String(paused));
      announcementToggle.setAttribute('aria-label', paused ? announcementToggle.dataset.playLabel : announcementToggle.dataset.pauseLabel);
    }
    const search = e.target.closest('[data-bbx-search-toggle]'); if(search) setSearch(!document.querySelector('[data-bbx-search-panel]')?.classList.contains('is-open'));
    const open = e.target.closest('[data-bbx-menu-open]'); if(open) setMenu(true);
    const close = e.target.closest('[data-bbx-menu-close]'); if(close || e.target.matches('[data-bbx-drawer]')) setMenu(false);
    const sticky = e.target.closest('[data-bbx-sticky-submit]'); if(sticky) document.querySelector('[data-bbx-product-form]')?.requestSubmit();
  });
  document.addEventListener('DOMContentLoaded',()=>init()); document.addEventListener('shopify:section:load',e=>init(e.target));
})();
